import { render, staticRenderFns } from "./TextComment.vue?vue&type=template&id=f4417a84&scoped=true"
import script from "./TextComment.vue?vue&type=script&setup=true&lang=ts"
export * from "./TextComment.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TextComment.vue?vue&type=style&index=0&id=f4417a84&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4417a84",
  null
  
)

export default component.exports